<template>
  <b-row class="w-100">
    <b-col md="12">
      <AppSpinner v-if="isLoading" size="3" class="d-block m-4 mx-auto text-secondary"/>
      <div class="clearfix centerDiv" style="text-align: center; margin-top: 5%;" v-else>
        <div class="clearfix" v-if="(all && message === 'Link is expired') || !all">
          <h1 id="status" class="pt-3">{{status}}</h1>
          <h2 id="message" class="text-muted">{{message}}</h2>
        </div>
        <div class="clearfix" v-else v-for="timesheet in timesheets">
          <h1 :id="'timesheet-'+timesheet.ID+'-success'" class="pt-3" v-if="timesheet.Error === null">Success</h1>
          <h1 :id="'timesheet-'+timesheet.ID+'-failed'" class="pt-3" v-else>Failed</h1>
          <h2 :id="'timesheet-'+timesheet.ID+'-approved'" class="text-muted" v-if="timesheet.Error === null">Timesheet {{timesheet.ID}}: is approved</h2>
          <h2 :id="'timesheet-'+timesheet.ID+'-error'" class="text-muted" v-else>Timesheet {{timesheet.ID}}: {{timesheet.Error}}</h2>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  import AppSpinner from "../../../components/common/utils/AppSpinner";
  import {approveTimesheetMail, approveAllTimesheetMail} from "../../../api/timesheet.api";

  export default {
    name: 'TimesheetApproved',
    components: {AppSpinner},
    props:{
      token: null
    },
    data() {
      return {
        status: null,
        approversNames: [],
        message: null,
        isLoading: true,
        all:false,
        timesheets:null,
      }
    },
    methods: {
      approveTimesheetMail() {
        approveTimesheetMail(this.token).then(
          (res) => {
            this.isLoading = false;
            this.all = false;
            if (res.data === "Link is expired, new email will be sent to approve it") {
              this.status = "Failed";
              this.message = res.data;
            }else if (res.data.ApproveResponse.Error === null) {
              this.status = "Success";
              this.message = "Timesheet is approved";
            } else {
              this.status = "Failed";
              this.message = res.data.ApproveResponse.Error;
            }
          },
          (error) => {
            this.isLoading = false;
            this.status = "Failed";
            this.message = error.response.data.error;
          }
        )
      },
      approveAllTimesheetMail() {
        approveAllTimesheetMail(this.token).then(
          (res) => {
            this.isLoading = false;
            if (res.data === "Link is expired, new email will be sent to approve it") {
              this.status = "Failed";
              this.message = res.data;
            } else {
              this.all = true;
              this.timesheets = res.data.BatchApproveResponse.Timesheets;
            }
          },
          (error) => {
            this.isLoading = false;
            this.status = "Failed";
            this.message = error.response.data.error;
          }
        )
      }
    },
    created() {
      if(this.token.includes('*')){
        this.approveAllTimesheetMail();
      } else {
        this.approveTimesheetMail();
      }
    },
  }
</script>
